export default {
  title: "Naam",
  input: {
    title: {
      base: "{{action}}",
      action: {
        update: "Persoon naam aanpassen",
        create: "Nieuw contactpersoon aanmaken",
      },
    },
    name: {
      label: "Naam"
    },
    firstName: {
      label: "Voornaam"
    },
    lastName: {
      label: "Achternaam"
    },
    lastNameAffix: {
      label: "Tussenvoegsel"
    },
    socialSecurityNumber: {
      label: "BSN"
    }
  }
}
